/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-30 13:58:11
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-11 16:45:17
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/slice/common.tsx
 */
import { createSelector } from '@reduxjs/toolkit';
import { EnumReducers as parentEnumReducers } from 'src/store';
import { getStateTarget as getTarget } from 'src/tools/helper';
import {
  getGeneralMiniProgramPageInfo as _getGeneralMiniProgramPageInfo,
  getGeneralMiniProgramShare as _getGeneralMiniProgramShare,
  getHasModified as _getHasModified,
  getLastModified as _getLastModified,
  getLoaded as _getLoaded,
  getState as _getState,
  getCollapseStatus,
  getTranslationState as _getTranslationState,
} from 'src/tools/selectors/salesChannel';

import { getI18nFromGeneral } from '@/src/tools/tools';
import { useSelector } from 'react-redux';
import { generateCollapseOpen } from 'src/constrains/SalesChannelPreviewPageComponents/tools';
import { NEW } from 'src/tools/constant';
import { assData } from 'src/tools/helper';

const legalReducers = (reducers) => {
  return [parentEnumReducers.salesChannelLegal, ...reducers];
};

const reducerTarget = (state, reducers) => {
  return getTarget(state, legalReducers(reducers));
};

const getAllCollapse = (reducer) => {
  return createSelector(
    (state: any) => reducerTarget(state, [reducer, 'collapseOpen']),
    (open) => {
      return open;
    },
  );
};

const getCollapse = (reducer, id) => {
  return getCollapseStatus(legalReducers([reducer]), id);
};

const getState = (reducer) => {
  return _getState(legalReducers([reducer]));
};

const getLoaded = (reducer) => {
  return _getLoaded(legalReducers([reducer]));
};

const getHasModified = (reducer) => {
  return _getHasModified(legalReducers([reducer]));
};

const getGeneralMiniProgramShare = (reducer) => {
  return _getGeneralMiniProgramShare(legalReducers([reducer]));
};

const getGeneralMiniProgramPageInfo = (reducer) => {
  return _getGeneralMiniProgramPageInfo(legalReducers([reducer]));
};

const getLastModified = (reducer) => {
  return _getLastModified(legalReducers([reducer]));
};
const getName = ({ uuid, getName: _getName }) => {
  const _isNew = uuid === NEW;
  const name = useSelector(_getName());
  return _isNew ? 'Add New Page' : name;
};

const willUnmount = ({ state, defaultState }) => {
  if (state.timeoutRef) {
    state.timeoutRef.forEach((i) => {
      try {
        clearTimeout(i);
      } catch (e) {
        console.warn(e);
      }
    });
  }
  assData(state, defaultState);
};

const getUuid = (reducer) => {
  return createSelector(
    (state: any) => reducerTarget(state, [reducer, 'uuid']),
    (state: any) => reducerTarget(state, [reducer, 'salesChannelUuid']),
    (uuid, salesChannelUuid) => {
      return { uuid: uuid || null, salesChannelUuid: salesChannelUuid || null };
    },
  );
};

export const getTranslationState = (reducer) => {
  return _getTranslationState(legalReducers([reducer]));
};

const common = {
  salesChannelUuid: null,
  loaded: false,
  storeUuid: '1',
  uuid: null,
  timeoutRef: [],
  salesChannelName: getI18nFromGeneral('general.sider.salesChannel'),
};

const defaultStatus = {
  dataValid: false,
  hasModified: false,
};

export {
  common,
  defaultStatus,
  generateCollapseOpen,
  getAllCollapse,
  getCollapse,
  getGeneralMiniProgramPageInfo,
  getGeneralMiniProgramShare,
  getHasModified,
  getLastModified,
  getLoaded,
  getName,
  getState,
  getUuid,
  reducerTarget,
  willUnmount,
};
